<template>
  <div>
    <p
      class="Hero-Text"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: width,
        'margin-top': marginTop,
      }"
    >
      Informasi Lainnya
    </p>

    <img
      src="../../assets/SyaratKetentuan/Hero.png"
      srcset="
        ../../assets/SyaratKetentuan/Hero@2x.png 2x,
        ../../assets/SyaratKetentuan/Hero@3x.png 3x
      "
      class="Hero"
    />

    <div class="d-flex justify-center mx-auto mt-8 subText">
      Laporan Keuangan
    </div>
    <div class="d-flex justify-center mx-auto mt-8">
      <div class="d-flex flex-row">
        <v-btn
          v-for="(rep, i) in reports"
          :key="i"
          x-large
          color="#D3352C"
          dark
          rounded
          class="mx-2"
          @click="toDetail(rep)"
        >
          {{ rep }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
      reports: [2020, 2021],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 3}px`;
      this.marginTop = `${window.innerWidth / 14}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 32}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    toDetail(rep) {
      this.$router.push("informasi-lainnya/" + rep);
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin-top: -80px;
  object-fit: contain;
}
.Hero-Text {
  width: 763px;
  height: 56px;
  margin: 101px 418px 0 419px;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
.subText {
  font-size: 18px;
  font-weight: bold;
  color: #252525;
}
</style>
